'use client';

import { LoginPage } from '@/components/auth';
export default function Page() {
  return <LoginPage data-sentry-element="LoginPage" data-sentry-component="Page" data-sentry-source-file="page.tsx" />;
}